import { createContext, Dispatch, SetStateAction } from 'react'
import { GoBackToEntry } from '../typings/GoBackToEntry'

export const GoBackToEntriesContext = createContext<
  [GoBackToEntry[], Dispatch<SetStateAction<GoBackToEntry[]>>] | undefined
>(undefined)
